/**
 * @namespace ExternalPlatforms
 * @aka SWRNEU.ExternalPlatforms
 */
(function ($) {
  window.trackers = [
    {
      "name": "Piano Analytics",
      "link": "https://www.piano.io/legal/privacy-policy",
      "techname": "atInternet",
      "info": "Mit AT Internet erfassen wir anonyme Nutzungsdaten für statistische Zwecke. Die Verarbeitung erfolgt datenschutzkonform innerhalb der EU.",
      "mehr": "zu Piano Analytics"
    },
    {
      "name": "AGF/Nielsen-Messverfahren",
      "link": "https://priv-policy.imrworldwide.com/priv/browser/de/de/optout.html",
      "techname": "agfNielsen",
      "info": "Nielsen analysiert anonym, wie unsere Website genutzt wird. Die Ergebnisse helfen uns, Inhalte und Angebote zu verbessern.",
      "mehr": "zum AGF/Nielsen-Messverfahren"
    },
    {
      "name": "Chartbeat",
      "link": "https://chartbeat.com/privacy/",
      "techname": "chartbeatOpt",
      "info": "Chartbeat wertet anonymisierte Nutzungsdaten in Echtzeit aus. So können wir Inhalte besser steuern und optimieren.",
      "mehr": "zu Chartbeat"
    }
  ];

  var embedTypes = [
    {
      "name": "Apester",
      "techname": "apester",
      "nOrM": "n"
    },
    {
      "name": "Bluesky",
      "techname": "bluesky",
      "nOrM": "n"
    },
    {
      "name": "Facebook",
      "techname": "facebook",
      "nOrM": "n"
    },
    {
      "name": "Giphy",
      "techname": "giphy",
      "nOrM": "n"
    },
    {
      "name": "Instagram",
      "techname": "instagram",
      "nOrM": "n"
    },
    {
      "name": "Mastodon",
      "techname": "mastodon",
      "nOrM": "n"
    },
    {
      "name": "Kurznachrichtendienst X",
      "techname": "twitter",
      "nOrM": "m"
    },
    {
      "name": "Spotify",
      "techname": "spotify",
      "nOrM": "n"
    },
    {
      "name": "TikTok",
      "techname": "tiktok",
      "nOrM": "n"
    },
    {
      "name": "Timeline",
      "techname": "timeline",
      "nOrM": "n"
    },
    {
      "name": "Twitch",
      "techname": "twitch",
      "nOrM": "n"
    },
    {
      "name": "Vimeo",
      "techname": "vimeo",
      "nOrM": "n"
    },
    {
      "name": "YouTube",
      "techname": "youtube",
      "nOrM": "n"
    }
  ];

  function getType(type) {
    var socialEmbed = this.embedTypes.find(({techname}) => techname === type);

    if ('undefined' === typeof socialEmbed) {
      return -1;
    }

    return socialEmbed;
  }

  SWRNEU.ExternalPlatforms = {
    embedTypes: embedTypes,
    getType: getType
  };
})(window.jQuery);
